import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SmashCardExpansionComponent } from './smash-card-expansion/smash-card-expansion.component';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [SmashCardExpansionComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [
    SmashCardExpansionComponent
  ]
})
export class SmashCardExpansionModule { }
